import GameConfig from "../core/data/GameConfig";
import { GameObject } from "../core/GameObject";
import { GameScene } from "../scenes/GameScene";
import { Coin } from "./Coin";
import { DestroyOffscreen } from "./DestroyOffscreen";
import { PlanckBodyComponent, PlanckBodyType } from "./PlanckBodyComponent";
import { SpineAnimation } from "./SpineAnimation";

export class CoinBag extends GameObject {
	spine: SpineGameObject;
	spineContainer: SpineContainer;
	scene: GameScene;

	constructor(scene: GameScene, x: number, y: number) {
		super(scene);
		const spineKey = "coin-bag";
		const spine = this.spine = scene.add.spine(0, 0, spineKey);
		spine.setDisplaySize(spine.displayWidth / 2, spine.displayHeight / 2);
		spine.play("idle", true);

		this.x = x;
		this.y = y;

		this.addComponent(new PlanckBodyComponent(this, PlanckBodyType.BOX, {
			x: this.x, y: this.y,
			width: spine.displayWidth, height: spine.displayHeight,
			worldScale: GameScene.worldScale,
			isSensor: false,
		}));

		this.addComponent(new SpineAnimation(this, spine, spineKey, true, 0, 0));
		this.addComponent(new DestroyOffscreen(this, true, false));
	}

	onCollect(): void {
		const destroyOffscreen = this.getComponent(DestroyOffscreen);
		if (!destroyOffscreen) return;
		this.removeComponent(destroyOffscreen);
		
		this.scene.soundManager.play("coinCollect");
		this.spine.play("burst", false);
		const numCoins = GameConfig.get<number>("coinBagValue");
		for (let i = 0; i < numCoins; i++){
			let everyOther = 0;

			const scene = this.scene;
			const coin = scene.ltGame.coinPool.get(this.x, this.y, everyOther % 2, false);
			scene.addObject(coin);
			everyOther++;

			//console.log("collectng coin from bag...");
			coin.onCollect(scene.ltGame.player);
			if(i = numCoins - 1){
				//console.log("destroy coin bag");
				coin.once("destroy", () =>{
					this.spine.once("complete", () =>{
						//console.log("trigger destroy");
						this.destroy();
					})
					
				});
				return;
			}
		}

	}
}